/**
 * TODO メモ欄のテンプレート定義
 *
 * Copilot CLI `todo-executor` スキル
 * (`.github/skills/todo-executor/SKILL.md`) の description テンプレに合わせた
 * 3 セクション + 進捗ログ構成。
 *
 * スキルはこのメモ (`text_documents`) を `agent_todo.py show` で読み、
 * `agent_append_memo.py` で追記する。追記スクリプトは見出し・チェックリスト・
 * 区切り線をこのテンプレートと同じノードに変換するため、見出しの文字列は
 * スキル側ドキュメントと揃えておくこと。
 */

import type { Editor } from '@tiptap/react'

const TEMPLATE_HTML = `
<h2>🎯 目的</h2>
<p></p>
<h2>✅ 完了条件</h2>
<ul data-type="taskList">
  <li data-type="taskItem" data-checked="false"><p></p></li>
</ul>
<h2>📂 ヒント</h2>
<p></p>
<hr>
<h2>📋 進捗ログ (エージェント追記欄)</h2>
<p></p>
`.trim()

/**
 * エディタの末尾にテンプレートを追記する。
 * 既存内容が空でも、内容があってもそのまま末尾に追加する。
 */
export const appendTodoMemoTemplate = (editor: Editor): void => {
  const endPos = editor.state.doc.content.size
  editor.chain().focus().insertContentAt(endPos, TEMPLATE_HTML).run()
}
